import AppointmentFlowHeaderContainer from './AppointmentFlowHeaderContainer';

export default AppointmentFlowHeaderContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentFlowHeader/index.js